import axios from "axios";
import fetch from "node-fetch";

export async function getPublicToken() {
    try {
        axios
            .get("https://ochad.connecthealthworks.co.uk/api/public", {
                headers: {
                    appname: "ChpsPremsProms",
                },
            })
            .then((result) => {
                //console.log(result.data)
                localStorage.setItem("access_token", result.data.access_token);
                localStorage.setItem("refresh_token", result.data.refresh_token);
                localStorage.setItem("expires_in", result.data.expires_in);
                localStorage.setItem("id_token", "public");
            })
            .catch((error) => console.error(error));
    } catch (error) {
        console.error(error);
    }
}

//if keysToTranslate is not equal to null then only stuff specified in this will be translated
export async function translateText(text, to, from, keysToIgnore, translationId = null) {
    var myHeaders = new Headers();
    myHeaders.append("keysToIgnore", keysToIgnore);
    myHeaders.append("to", to);
    myHeaders.append("from", "en");
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: text,
        redirect: "follow",
        translationId,
    };

    let response = await fetch(
        "https://ochad.connecthealthworks.co.uk/api/google/translateTextFromJson",
        requestOptions
    )
        .then((response) => response.text())
        .then((result) => {
            return result;
        })
        .catch((error) => {
            console.error("error", error);
            return "errorOccured";
        });

    if (response == "errorOccured") {
        alert("An error occured during translating!"); //some languages have characters that break the JSON
        return null;
    }

    response = decodeURI(response);
    if (!IsJsonValid(response)) alert("Unable to translate!"); //some languages have characters that break the JSON

    response = JSON.parse(response);
    return response;
}

function IsJsonValid(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
